import { Icon, Logo } from "components";
import { DownloadBox } from "containers";

export default function Offline() {
  return (
    <section className="w-full min-h-[100svh] flex flex-col">
      <div className="w-full m-auto flex flex-col items-center text-center py-10 px-5">
        <Logo variant="DEFAULT-2" className="w-32" />
        <Icon
          name="Danger"
          variant="Bold"
          className="size-[7.5rem] text-[#ECEFF2] mt-16"
        />
        <p className="text-lg text-[#5E6278] font-semibold mt-5">
          No internet connection
        </p>
        <p className="text-sm text-[#5E6278] font-medium mt-2.5">
          Please check your network connection and try again.
        </p>
        <DownloadBox className="mt-12" />
      </div>
    </section>
  );
}
